import React, { useEffect } from 'react';
import { StyleSheet, Image, useWindowDimensions } from 'react-native';
import { Col, Row, useDynamicResponsiveValue, Text, Scroll } from 'react-quick-style-components';
import { useNavFunc } from 'navigation';
import { IScreen } from 'type';
import { ASSETS, DEVICE_INFO, COLOR, fSize } from 'const';
import { Footer, Header } from "components"
import Store from 'store';
import { TimeHelper, VarHelper } from 'helpers';
import moment from 'moment';

import './NewDetail.css';

const NewDetail: IScreen = () => {
  const { route } = useNavFunc();
  const { id }: any = route.params || {};
  const [{ listNews, listPages }, iApi] = Store.Info.createStore();
  const { width } = useWindowDimensions();
  const rV = useDynamicResponsiveValue();

  useEffect(() => {
    iApi.getListNews();
    iApi.getListPages();
  }, []);

  const newData = listNews.find(val => val.id == id) || {
    Title: '',
    Content: '',
    Image: '',
    // name: 'John Doe',
  };

  // console.log('listNews', listNews);
  // console.log('newData', newData, id);

  const IMAGE_WIDTH = rV({ xs: width - 40, md: width / 3, lg: width / 3 });

  const pageData = listPages.find(val => val.Title === 'News');
  const pageDataImages = VarHelper.imgApiStringifyGetAll(pageData?.Images);

  return (
    <Col flex1 backgroundColor={COLOR.BG}>
      <Scroll flex1>
        <Header />
        <Col middle>
          <Image source={pageDataImages.length > 0 ? { uri: pageDataImages[0] } : ASSETS.IMG_CASKS_HEADER} style={{ width: '100%', height: rV({ xs: DEVICE_INFO.WIDTH / 3.6, lg: DEVICE_INFO.WIDTH / 7.3 }), resizeMode: 'cover' }} />
          <Col middle style={{ position: 'absolute' }}>
            <Text color={COLOR.WHITE} fontSize={fSize(rV, 52)} marginBottom10>
              News
            </Text>
            <Image source={ASSETS.IMG_WHITESWIRL} style={{ width: fSize(rV, 146), height: fSize(rV, 21), resizeMode: 'contain' }} />
          </Col>
        </Col>
        <Col flex1 paddingHorizontal20>
          <Row middle marginTop20>
            <Text center color={COLOR.MAIN} fontSize={fSize(rV, 30)}>
              {newData.Title}
            </Text>
            {/* <Text color={COLOR.MAIN} fontSize={fSize(rV, 20)} marginLeft20>
                  {newData.name}
                </Text> */}
            <Col width8 height8 borderRadius4 backgroundColor={COLOR.MAIN} marginHorizontal10 />
            <Text color={COLOR.MAIN} fontSize={fSize(rV, 16)}>
              {newData.created_at ? moment(newData.created_at).format('DD/MM/YYYY') : ''}
            </Text>
          </Row>
          {/* <Text color={COLOR.FONT} body1 marginTop={rV({ xs: 20, md: 20, lg: 40 })}>
                
              </Text> */}
          <Col marginTop={rV({ xs: 20 })} paddingHorizontal20 width="80%" maxWidth={1200} alignSelf="center">
            <div className="news-content" dangerouslySetInnerHTML={{ __html: newData.Content }} style={{ fontSize: 16 }}>
            </div>
          </Col>
        </Col>
        <Footer />
      </Scroll>
    </Col>
  );
};

NewDetail.routeInfo = {
  title: 'News Detail',
  path: '/news/:id',
};

export default NewDetail;